var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "address relative" },
    [
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.address,
            expression: "address",
          },
        ],
        staticClass: "complete-address form-input",
        attrs: {
          type: "text",
          disabled: _vm.disabled,
          placeholder: _vm.$t("global.completeAddress"),
        },
        domProps: { value: _vm.address },
        on: {
          keyup: _vm.handleGeolocation,
          input: [
            function ($event) {
              if ($event.target.composing) {
                return
              }
              _vm.address = $event.target.value
            },
            _vm.handleInput,
          ],
        },
      }),
      _vm._v(" "),
      _vm.isLoading
        ? _c("UiSpinner", {
            staticStyle: {
              position: "absolute",
              right: "10px",
              top: "11px",
              "pointer-events": "none",
            },
            attrs: { size: "sm" },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.result
        ? _c(
            "div",
            {
              directives: [
                {
                  name: "click-outside",
                  rawName: "v-click-outside",
                  value: _vm.onClickOutside,
                  expression: "onClickOutside",
                },
              ],
              staticClass: "autocomplete-result",
            },
            [
              _c(
                "ul",
                _vm._l(_vm.result, function (item, index) {
                  return _c(
                    "li",
                    {
                      on: {
                        click: function ($event) {
                          return _vm.chooseAddress(index)
                        },
                      },
                    },
                    [_vm._v("\n        " + _vm._s(item.address) + "\n      ")]
                  )
                }),
                0
              ),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }